module.exports = __webpack_public_path__ + "img/service-zhinengcuishou2.58aa38c8.svg";